import MiniSearch from 'minisearch'

let miniSearch = null

export const SearchService = {
  buildIndex(indexEntries) {
    miniSearch = new MiniSearch({
      fields: ['title', 'keywords', 'summary', 'category'],
      storeFields: ['id', 'title', 'category', 'summary', 'url'],
      searchOptions: {
        boost: { title: 3, keywords: 2 },
        fuzzy: 0.2,
        prefix: true,
      },
    })

    const docs = indexEntries.map(entry => ({
      id: entry.id,
      title: entry.title ?? '',
      keywords: Array.isArray(entry.keywords) ? entry.keywords.join(' ') : (entry.keywords ?? ''),
      summary: entry.summary ?? '',
      category: entry.category ?? '',
      url: entry.url ?? '',
    }))

    miniSearch.addAll(docs)
  },

  search(query) {
    if (!miniSearch) return []
    return miniSearch.search(query)
  },

  suggest(query) {
    if (!miniSearch) return []
    return miniSearch.autoSuggest(query)
  },
}
